import React, { useEffect } from 'react';
import { View } from "@/styles/reactnative";

const DerivativesNavBarTabs = React.memo(({ tab, setTab, t, textsilver }:any) => {
  // console.log('렌더링됨')
  const tabs = ["L", "M", "CL"];



  return (
    <View
      style={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingLeft: 10,
        paddingTop: 16,
        width: "100%",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          justifyContent: "flex-start",
          gap: 16,
          width: "100%",
          flexWrap: "wrap",
          background: "transparent",
          borderRadius: 10,
        }}
      >
        {tabs?.map((item, index) => {
          let temp = tab;

          if (temp == "CM") {
            temp = "CL";
          } else {
            if (temp == "CL") {
              temp = "CL";
            }
          }

          return (
            <button
              key={`DerivativesNavBarTabs_${index}`}
              style={{
                color: item == temp ? '#F87943' : textsilver,
                borderBottom: item == temp ? '2px solid #F87943' : '0',
                borderTop: 0,
                borderLeft: 0,
                borderRight: 0,
                padding: "10px 0",
                fontWeight: 600,
                fontSize: 14,
                lineHeight: '16.71px'
              }}
              onClick={() => setTab(item)}
            >
              {t(
                item == "L"
                  ? "limit"
                  : item == "M"
                  ? "market"
                  : item == "T" || item == "CM" || item == "CL"
                  ? "trigger"
                  : ""
              )}
            </button>
          );
        })}
      </View>

      {/* <Space.Compact
				size="small"
				style={{ width: '100%', flexWrap: 'wrap', marginBottom: 1 }}>
				<Button
					style={
						tab != 'L'
							? {
									color: textw,
									background: isMobile ? drawerBgColor : bgColor,
									borderColor: grey,
									width: '50%',
							  }
							: { width: '50%' }
					}
					onClick={() => setTab('L')}
					type={tab == 'L' ? '' : 'default'}>
					{t('limit')}
				</Button>
				<Button
					style={
						tab != 'M'
							? {
									color: textw,
									background: isMobile ? drawerBgColor : bgColor,
									borderColor: grey,
									width: '50%',
							  }
							: { width: '50%' }
					}
					onClick={() => setTab('M')}
					type={tab == 'M' ? 'primary' : 'default'}>
					{t('market')}
				</Button>
			</Space.Compact>
			<Space.Compact
				size="small"
				style={{ width: '100%', flexWrap: 'wrap' }}>
				<Button
					style={
						tab != 'CL'
							? {
									color: textw,
									background: isMobile ? drawerBgColor : bgColor,
									borderColor: grey,
									width: '50%',
							  }
							: { width: '50%' }
					}
					onClick={() => setTab('CL')}
					danger
					type={tab == 'CL' ? 'primary' : 'default'}>
					{t('climit')}
				</Button>
				<Button
					style={
						tab != 'CM'
							? {
									color: textw,
									background: isMobile ? drawerBgColor : bgColor,
									borderColor: grey,
									width: '50%',
							  }
							: { width: '50%' }
					}
					onClick={() => setTab('CM')}
					danger
					type={tab == 'CM' ? 'primary' : 'default'}>
					{t('cmarket')}
				</Button>
			</Space.Compact> */}
    </View>
  );
}, (prevProps, nextProps) => {
  return (
    prevProps.tab === nextProps.tab &&
    prevProps.textsilver === nextProps.textsilver &&
    prevProps.t === nextProps.t
  );
});

export default DerivativesNavBarTabs;
